import { NAVIGATE_TO_EQUIPMENT } from "../constants/actionTypes";

export default url => {
  window.location.href = url;

  return { type: NAVIGATE_TO_EQUIPMENT };
};
